"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSharedState = exports.setSharedState = exports.SHARE_STATE_KEY = void 0;
const lodash_1 = require("lodash");
exports.SHARE_STATE_KEY = '@w-flow-shared-state';
function setSharedState(graph, state) {
    (0, lodash_1.set)(graph, exports.SHARE_STATE_KEY, state);
}
exports.setSharedState = setSharedState;
function getSharedState(graph) {
    return (0, lodash_1.get)(graph, exports.SHARE_STATE_KEY);
}
exports.getSharedState = getSharedState;
//# sourceMappingURL=SharedState.js.map